import { type I18NLocale } from 'Locale';

export enum LockedTutorBotChatState {
    Unavailable = 'Unavailable',
    InProgressExam = 'InProgressExam',
}

export enum UnlockedTutorBotChatState {
    CanApply = 'UnlockedTutorBotChatState.CanApply',
    CannotApply = 'UnlockedTutorBotChatState.CannotApply',
    Applied = 'UnlockedTutorBotChatState.Applied',
    AppliedInterviewPending = 'UnlockedTutorBotChatState.AppliedInterviewPending',
    NotOfferedAdmission = 'UnlockedTutorBotChatState.NotOfferedAdmission',
    OfferedAdmission = 'UnlockedTutorBotChatState.OfferedAdmission',
    OfferExpired = 'UnlockedTutorBotChatState.OfferExpired',
    RegisteredNotCurrent = 'UnlockedTutorBotChatState.RegisteredNotCurrent',
    IncludedOrGraduated = 'UnlockedTutorBotChatState.IncludedOrGraduated',
    ExpelledOrWithdrawn = 'UnlockedTutorBotChatState.ExpelledOrWithdrawn',
}

export type TutorBotChatState = LockedTutorBotChatState | UnlockedTutorBotChatState;

type TutorBotChatBaseConfig<T extends { isLocked: boolean }> = {
    isLocked: T['isLocked'];
    welcomeModalTexts: readonly I18NLocale[];
    welcomeModalCta?: {
        message: { headline: I18NLocale; subtext?: I18NLocale };
        buttonText: I18NLocale;
        onClick: () => void;
    };
    greetingMessages: readonly I18NLocale[];
    hasSeenInitialGreetingLocalStorageKey: string | null; // null means it will show the greeting every time
    inputLabel: I18NLocale | null;
};

export type TutorBotChatLockedConfig = TutorBotChatBaseConfig<{ isLocked: true }>;
export type TutorBotChatUnlockedConfig = TutorBotChatBaseConfig<{ isLocked: false }>;

// There is an invalid state, but there is no invalid status config, because if we
// ever somehow run into an invalid state (which is unexpected), we will just show
// the Unavailable status config (see useTutorBotStatusConfig)
export type TutorBotChatStatusConfig = TutorBotChatLockedConfig | TutorBotChatUnlockedConfig;
